var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.44125 0.416696C1.60932 0.416146 1.77538 0.451866 1.92723 0.521229C2.07908 0.590594 2.21287 0.691841 2.31875 0.81753L7.7525 7.31753C7.91797 7.51137 8.00842 7.75452 8.00842 8.00545C8.00842 8.25637 7.91797 8.49952 7.7525 8.69336L2.1275 15.1934C1.93654 15.4146 1.66214 15.5537 1.36466 15.5801C1.06718 15.6065 0.770992 15.5181 0.541248 15.3342C0.311504 15.1503 0.167028 14.8861 0.1396 14.5996C0.112173 14.3131 0.204042 14.0279 0.394998 13.8067L5.42375 8.00003L0.56375 2.19336C0.426182 2.03434 0.338794 1.84071 0.31193 1.63536C0.285066 1.43002 0.319847 1.22156 0.41216 1.03466C0.504473 0.847751 0.650453 0.690222 0.832827 0.580708C1.0152 0.471194 1.22634 0.414278 1.44125 0.416696Z","fill":"white"}));
}

RightArrow.defaultProps = {"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
